export default "__VITE_ASSET__31fdb03b__"